// // src/app/amplify-config.ts
// import { Amplify } from 'aws-amplify';
// import '@aws-amplify/auth';

// Amplify.configure({
//     aws_project_region: 'us-east-1',
//     aws_cognito_region: 'us-east-1',
//     aws_user_pools_id: 'us-east-1_ZoyJ8C9eL',
//     aws_user_pools_web_client_id: '50pd56j95lmsktnut8vn7vsgan',
//   } as any);
  